import { useState } from 'react';

import { Trans, useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Checkbox,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
  itemVariants,
  Label,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { useAtom } from 'jotai';

import { isAiHubWelcomeModalShownAtom } from '../../store/welcomeModal.js';
import poweredByAi from './poweredByAi.png';

const WelcomeModalMobile = () => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const [isShown, setIsShown] = useAtom(isAiHubWelcomeModalShownAtom);
  const [isOpen, setIsOpen] = useState(isShown);

  const toggleIsShown = (e: boolean) => {
    setIsShown(!e); // `checked` prop
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Drawer open={isOpen} onOpenChange={(open) => !open && setIsOpen(false)}>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerRoot
          side="bottom"
          aria-describedby={undefined}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <DrawerHeader>
            <DrawerTitle>{t('Welcome to MintIQ')}</DrawerTitle>
          </DrawerHeader>

          <DrawerContent className="flex flex-col gap-9">
            <div className="flex flex-col gap-4">
              <img src={poweredByAi} alt="Powered by AI" />
              <Trans
                i18nKey="<Phrase>The MINT Agentic tools are <Bold>powered by AI</Bold></Phrase>"

                t={t}
                components={{
                  Phrase: (
                    <div
                      className={cn(
                        'flex flex-row gap-1',
                        typographyVariants({
                          variant: 'bodyLong01',
                        }),
                      )}
                    />
                  ),
                  Bold: (
                    <div
                      className={typographyVariants({
                        variant: 'bodyLong02',
                      })}
                    />
                  ),
                }}
              />

              <Label
                htmlFor="dont-show-again"
                variant="bodyLong01"
                className={cn(itemVariants({ popoverItem: 'default' }))}
              >
                <Checkbox
                  id="dont-show-again"
                  onCheckedChange={(e) => toggleIsShown(e as boolean)}
                />
                {t("Don't show this again")}
              </Label>
            </div>
            <Button
              variant="contained"
              className="w-full"
              size={'largeMobile'}
              onClick={onClose}
            >
              {t('I got it')}
            </Button>
          </DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
    </Drawer>
  );
};

export { WelcomeModalMobile };
